import React from 'react'
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

class EventMap extends React.Component {

  render() {


  		let center = {lat : this.props.lat * 1, lng : this.props.long * 1};
      let height = this.props.height ? this.props.height : "350px";

      const MapWithAMarker = withScriptjs(withGoogleMap(props =>
        <GoogleMap
          defaultZoom={15}
          defaultCenter={center}
        >
          <Marker
            position={center}
          />
        </GoogleMap>
      ));

      return <MapWithAMarker
                    googleMapURL="https://maps.googleapis.com/maps/api/js?v=3.exp&libraries=geometry,drawing,places&key=AIzaSyC1EIlqtaNjC0EXm2ls4KGDbspTCFzgpT0"
                    loadingElement={<div style={{ height: `100%` }} />}
                    containerElement={<div style={{ height: height }} />}
                    mapElement={<div style={{ height: `100%` }} />}
                  />
	}
}
export default EventMap


// WEBPACK FOOTER //
// ./src/components/Event/Map.js